import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CurrentUserService } from '../services/currentUser.service';
import { CaseConfigService } from '@shared/services/case-config.service';

@Injectable()
export class TenantGuard {
  private router = inject(Router);
  private currentUserService = inject(CurrentUserService);
  private caseConfigService = inject(CaseConfigService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    routerState: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    const tenantParam = route.queryParams?.['tenant'];
    try {
      await this.currentUserService.setCurrentUser(true, tenantParam);
    } catch {
      return false;
    }

    const userTenant = this.currentUserService.currentUser.tenantId;
    if (
      tenantParam !== userTenant &&
      this.currentUserService.currentUser?.permissions[0] !== 'full_access'
    ) {
      const urlTree = this.router.parseUrl(routerState.url);
      urlTree.queryParams['tenant'] = userTenant;
      return urlTree;
    }

    if (!tenantParam) {
      const urlTree = this.router.parseUrl(routerState.url);
      urlTree.queryParams['tenant'] = userTenant;
      return urlTree;
    }

    await this.caseConfigService.loadCaseConfig(userTenant);

    return true;
  }
}
